import { defineComponent as _defineComponent } from 'vue'
import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-030c147e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex items-center" }
const _hoisted_2 = ["value", "id", "disabled"]
const _hoisted_3 = ["for"]

import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  checked: {
    type: [Boolean, Array],
    default: false
  },
  value: {
    type: String,
    default: null
  },
  fieldId: {
    type: String,
    required: true
  },
  disabled: {
    type: Boolean,
    required: false
  },
  label: String
},
  emits: ['update:checked'],
  setup(__props, { emit }) {

const props = __props;





const isChecked = computed({
  get() {
    return props.checked
  },
  set(newValue) {
    emit('update:checked', { isChecked: newValue, value: props.value })
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      type: "checkbox",
      value: props.value,
      id: __props.fieldId,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isChecked).value = $event)),
      class: "mr-4 checkbox disabled:bg-gray-200",
      disabled: __props.disabled
    }, null, 8, _hoisted_2), [
      [_vModelCheckbox, isChecked.value]
    ]),
    _createElementVNode("label", {
      for: __props.fieldId,
      class: _normalizeClass(["flex text-left flex-row items-center cursor-pointer select-none", __props.disabled && 'text-[#9E9EB7]'])
    }, _toDisplayString(__props.label), 11, _hoisted_3)
  ]))
}
}

})